module.exports = {
  title: '新人专享商品',
  route: {
    path: '/marketing-tools',
    children: {
      path: 'exclusive-product-new-people',
    },
  },
};
